import { get, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

import * as apis from 'apis';
import Context from './Context';
import { useApi } from 'providers/Api';
import { useToast } from 'hooks/useToast';
import { useLiff } from 'providers/Liff';

import Loading from 'components/Loader';

import { ENV_TYPES, GA_UTM_CAMPAIGN, GA_UTM_MEDIUM, GA_UTM_SOURCE } from 'configs/constant';
import configs from 'configs/envConfig';
import { goOa, isMobile } from 'utils/methods';

const setAccessTokenToLocoalStorage = async (accessToken) => localStorage.setItem('accessToken', accessToken);

const { STAGE } = configs;
const Provider = ({ children }) => {
    const [liffAuth, setLiffAuth] = useState({});
    const [auth, setTpAuth] = useState({});
    const [fetched, setFetched] = useState(false);
    const { liff, ready } = useLiff();
    const { withApis } = useApi();
    const { danger } = useToast();
    const qs = new URLSearchParams(window.location.search);

    const isLocal = STAGE === ENV_TYPES.LOCAL;
    const isTest = qs.get('env') === 'test';

    const getCreateClient = async (profile, accessToken) => {
        const recommendLineId = qs.get('recommendId') || '';
        const [resp] = await withApis([apis.getStoreCreateCustomer({ recommendLineId, lineId: profile.userId, profile }, accessToken)]);
        return resp;
    };

    async function getClientProfiles(liff) {
        try {
            const profile = await liff.getProfile().catch((error) => {
                console.error(error);
                liff.logout();
                liff.login({ redirectUri: window.location.href });
                return false;
            });
            if (!profile) return { error: true };

            const profilePlus = liff.getDecodedIDToken() || {};
            const accessToken = liff.getAccessToken();
            await setAccessTokenToLocoalStorage(accessToken);
            const lineId = profile.userId;
            const auth = await getCreateClient(profile, accessToken);
            if (auth.err || auth.error) return { error: true };
            return { profile, accessToken, profilePlus, lineId, auth: get(auth, 'data', {}) };
        } catch (error) {
            console.log('getClientProfiles', error);
            return { error };
        }
    }

    const postUtm = (lineId) => {
        const searchParams = new URLSearchParams(window.location.search);
        const source = searchParams.get(GA_UTM_SOURCE) || '';
        const medium = searchParams.get(GA_UTM_MEDIUM) || '';
        const campaign = searchParams.get(GA_UTM_CAMPAIGN) || '';
        apis.createUtmLog({ lineId, source, medium, campaign });
    };

    const getClient = async () => {
        const { profile, accessToken, lineId, error, auth } = await getClientProfiles(liff);
        if (isEmpty(profile) || error) {
            danger('請登入後再試一次');
            return false;
        }
        setLiffAuth({ accessToken, lineId, profile });
        setTpAuth(auth);

        return { accessToken, lineId, profile };
    };

    const init = async () => {
        const [auth] = await Promise.all([getClient()]);
        postUtm(auth.lineId);
        if (auth) setFetched(true);
    };

    useEffect(() => {
        console.log('auth provider', liff, ready);
        if (!liff || !ready) return;

        if (!isLocal && !isTest && !isMobile()) return goOa();
        if (!isLocal && !liff.isLoggedIn()) return liff.login({ redirectUri: window.location.href });

        async function checkFriendShip() {
            if (isLocal) return init();

            const res = await liff.getFriendship();
            console.log('isFriendship', res);
            if (!res.friendFlag) goOa();
            else init();
        }

        if (isEmpty(auth)) checkFriendShip();
    }, [liff, ready]);

    const props = {
        liffAuth,
        auth,
        refreshAuth: getClient,
        setTpAuth
    };

    return <Context.Provider value={{ ...props }}>{fetched ? children : <Loading />}</Context.Provider>;
};

export default Provider;
